import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isPaid, markPaid } from '../utils/payments';

// Envía a login (o landing) si no hay evidencia de pago en localStorage.
// Acepta query strings como ?paid=1&plan=basic para marcar pago (útil para Hosted Buttons con return URL).
export default function PaidGate({ children }) {
  const location = useLocation();

  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search || '');
      const paid = params.get('paid');
      const plan = params.get('plan') || undefined;
      const ref = params.get('ref') || undefined;
      if (paid === '1' || paid === 'true') {
        markPaid('query', plan || 'unknown', ref);
      }
    } catch {}
  }, [location.search]);

  if (!isPaid()) {
    // Redirigir a login con motivo
    return <Navigate to={`/login?needPayment=1`} replace />;
  }
  return children;
}
